import { api } from '@verifime/api-definition';
import {
  CircularProgressButton,
  enqueErrorNotification,
  enqueSuccessNotification,
} from '@verifime/components';
import { useState } from 'react';

export const RequestAddCredential = ({
  customerId,
  onSuccess,
  onFailure,
}: {
  customerId: string;
  onSuccess?: () => void;
  onFailure?: (error: any) => void;
}) => {
  const [submitting, setSubmitting] = useState(false);
  const handleAddCredential = () => {
    setSubmitting(true);
    api
      .postV1taskcustomerCustomerId(
        { type: 'CREDENTIAL_SETUP' },
        {
          params: { customerId },
        },
      )
      .then(() => {
        enqueSuccessNotification('Credential setup requested successfully');
        onSuccess?.();
      })
      .catch((err: unknown) => {
        const errorMessage = err instanceof Error ? err.message : 'An unknown error occurred';
        enqueErrorNotification(`Request failed: ${errorMessage}`);
        onFailure?.(err);
      })
      .finally(() => {
        setSubmitting(false);
      });
  };
  return (
    <CircularProgressButton onClick={handleAddCredential} isShowProgress={submitting} disabled>
      Request add Credential
    </CircularProgressButton>
  );
};
